import React, { FC } from "react";
import Avatar from "components/Avatar/Avatar";
import { PostDataType } from "data/types";
import { Link } from "react-router-dom";
import {dateConverter} from "../../utils";

export interface PostCardMetaProps {
  className?: string;
  meta: Pick<PostDataType, "date" | "author">;
  hiddenAvatar?: boolean;
  size?: "large" | "normal";
  onInvalidClick?: () => void;
}

const PostCardMeta: FC<PostCardMetaProps> = ({
  className = "leading-none",
  meta,
  hiddenAvatar = false,
  size = "normal",
  onInvalidClick,
}) => {
  const { date, author} = meta;
  const isInvalidUser = author?.id === "0";

  const handleAuthorClick = (e: React.MouseEvent) => {
    if (isInvalidUser) {
      e.preventDefault();
      onInvalidClick?.();
    }
  };
  
  return (
    <div
      className={`nc-PostCardMeta flex flex-col text-neutral-800 dark:text-neutral-200 ${
        size === "normal" ? "text-xs" : "text-base"
      } ${className}`}
      data-nc-id="PostCardMeta"
    >
      <Link to={isInvalidUser ? "#" : author.href} onClick={handleAuthorClick} aria-label="author details page" className={`relative flex items-center space-x-2 ${isInvalidUser ? "cursor-default" : ""}`}>
        {!hiddenAvatar && (
          <Avatar
            radius="rounded-full"
            sizeClass={
              size === "normal" ? "h-7 w-7 text-sm" : "h-10 w-10 text-xl"
            }
            imgUrl={author.avatar}
            userName={author.displayName}
          />
        )}
        
        <div className="flex flex-col leading-tight">
        <span className="block text-neutral-700 hover:text-black dark:text-neutral-300 dark:hover:text-white font-medium">
          {(author.displayName).substr(0, 18)}{(author.displayName).length > 18 && "..."}
        </span>
        <span className="text-neutral-500 dark:text-neutral-400 font-normal">
          {dateConverter(date)}
        </span>
        </div>
      </Link>
    </div>
  );
};

export default PostCardMeta;
